module.exports = __webpack_public_path__ + "media/images/product_lines/car/banner_bg-3e87b2f6a82359688d0b8905b4a29981.svg";